import React from "react";
import { useMediaQuery } from "react-responsive";

import TailoredSolutionsContentMobile from "./Mobile";
import TailoredSolutionsContentDesktop from "./Desktop";
import { MOBILE_BREAKPOINT } from "../../../../lib/constants";

function TailoredSolutionsContent() {
  const isMobile = useMediaQuery({ maxWidth: MOBILE_BREAKPOINT });

  return (
    <>
      {isMobile ? (
        <TailoredSolutionsContentMobile />
      ) : (
        <TailoredSolutionsContentDesktop />
      )}
    </>
  );
}

export default TailoredSolutionsContent;
